<template lang="pug">
v-dialog(v-model="dialog" width="600" persistent)
    template(v-slot:activator="{ on, attrs }")
        v-btn.ml-2(small fab color="primary" dark v-bind="attrs" v-on="on")
            v-icon(small) mdi-plus
    v-card(:loading="loading")
        v-card-title Add custom survey to target user.
        v-card-text
            center
                v-avatar.mt-8(v-if="user.avatar" :size="45")
                    img(:src="user.avatar")
                div(v-if="user.name") {{ user.name }}
                select-user(:label="user.avatar ? 'Change User' : 'Select User'" @select="selectUser" :disabled="loading")
                

            feathers-vuex-find(service="bh-survey-options" :query="optionQuery" :fetch-query="optionFetchQuery" watch="query")
                template(slot-scope="{ items }")
                    v-combobox(
                        v-model="main_question"
                        :items="items"
                        label="Type or Select Main Question"
                        outlined
                        dense
                        item-text="title"
                        item-value="id"
                        :disabled="loading"
                    )

            feathers-vuex-find(service="bh-survey-options" :query="option2Query" :fetch-query="option2FetchQuery" watch="query")
                div(slot-scope="{ items }")

                    v-expansion-panels
                        v-expansion-panel
                            v-expansion-panel-header
                                b YES
                            v-expansion-panel-content
                                v-combobox(
                                    v-model="form.data.yes[0]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )

                                v-combobox(
                                    v-model="form.data.yes[1]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )

                                v-combobox(
                                    v-model="form.data.yes[2]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )

                                v-combobox(
                                    v-model="form.data.yes[3]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )

                                v-combobox(
                                    v-model="form.data.yes[4]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )

                        v-expansion-panel
                            v-expansion-panel-header
                                b NO
                            v-expansion-panel-content
                                v-combobox(
                                    v-model="form.data.no[0]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )

                                v-combobox(
                                    v-model="form.data.no[1]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )

                                v-combobox(
                                    v-model="form.data.no[2]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )

                                v-combobox(
                                    v-model="form.data.no[3]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )

                                v-combobox(
                                    v-model="form.data.no[4]"
                                    :items="items"
                                    label="Type or Select Question"
                                    outlined
                                    dense
                                    item-text="title"
                                    item-value="id"
                                    :disabled="loading"
                                )
                
        v-snackbar(v-model="error.show" top color="red")
            v-icon(left) mdi-alert-circle-outline
            | {{ error.message }}
            template(v-slot:action="{ attrs }")
                v-btn(
                    color="white"
                    text
                    v-bind="attrs"
                    @click="error.show = false"
                ) Close

        v-divider
        v-card-actions
            v-spacer
            v-btn(v-if="!loading" small color="red" text @click="dialog = false") Cancel
            v-btn(small color="primary" text @click="submit" :loading="loading") Submit
            
</template>

<script>
import { mapActions } from 'vuex';
import SelectUser from './SelectUser.vue';

export default {
    data() {
        return {
            dialog: false,
            loading: false,
            user: {
                avatar: null,
                name: null
            },
            error: {
                show: false,
                message: null
            },
            main_question: null,
            form: {
                user_id: null,
                data: {
                    yes: [null, null, null, null, null],
                    no: [null, null, null, null, null]
                }
            }
        };
    },
    computed: {
        optionQuery() {
            return { type: '"bool"' };
        },
        optionFetchQuery() {
            return { type: '"bool"', $paginate: 'false' };
        },
        option2Query() {
            return { type: { $ne: '"bool"' } };
        },
        option2FetchQuery() {
            return { type: { $ne: '"bool"' }, $paginate: 'false' };
        }
    },
    methods: {
        selectUser(item) {
            this.form.user_id = item.id;
            this.user.avatar = item.profile_picture_thumb;
            this.user.name = item.artist_name;
        },
        async submit() {
            try {
                this.loading = true;
                if(!this.form.user_id) throw new Error('Please select user artist.');
                if(this.form.data.yes.filter(i => !!i).length  === 0) throw new Error('Please fille some "YES" options.');
                if(this.form.data.no.filter(i => !!i).length  === 0) throw new Error('Please fille some "NO" options.');
                if(!this.main_question) throw new Error('Please select main question.');
                
                if(typeof this.main_question === 'string') {
                    const result = await this.createRole({
                        title: this.main_question,
                        type: '"bool"'
                    });
                    this.main_question = result;
                }

                const yesOptions = await Promise.all(this.form.data.yes.filter(i => !!i).map(async item => {
                    if(item && typeof item === 'string') {
                        const result = await this.createRole({
                            title: item,
                            option_description: '["Terrible", "Indifferent / Doesn’t stand out", "Just ok", "I like it", "Going to be a hit"]',
                            type: '{"type":"int", "data": [1,2,3,4,5]}'
                        });
                        return result.id;
                    }
                    return item.id;
                }));

                const noOptions = await Promise.all(this.form.data.no.filter(i => !!i).map(async item => {
                    if(item && typeof item === 'string') {
                        const result = await this.createRole({
                            title: item,
                            option_description: '["Terrible", "Indifferent / Doesn’t stand out", "Just ok", "I like it", "Going to be a hit"]',
                            type: '{"type":"int", "data": [1,2,3,4,5]}'
                        });
                        return result.id;
                    }
                    return item.id;
                }));

                const resultData = {
                    [this.main_question.id]: {
                        yes: yesOptions,
                        no: noOptions
                    }
                };

                await this.createCustomSurvey({
                    user_id: this.form.user_id,
                    survey_tree: JSON.stringify(resultData)
                });

                this.$emit('success');

                this.dialog = false;
            } catch(err) {
                console.log(err);
                this.error.message = err.message;
                this.error.show = true;
            } finally {
                this.loading = false;
            }
        },
        itemCheck(item) {
            return typeof item !== 'object'
        },
        ...mapActions('bh-survey-options', { createRole: 'create' }),
        ...mapActions('bh-user-survey-custom', { createCustomSurvey: 'create' })
    },
    components: {
        SelectUser
    },
}
</script>